import moment from 'moment';

export function humanizeDate(date, locale = 'ru') {
  const humanizedDate = moment(date);
  const daysPassed = (moment() - humanizedDate) / 1000 / 60 / 60 / 24;
  if (daysPassed < 5) {
    return humanizedDate.locale(locale).fromNow();
  }
  return humanizedDate.locale(locale).format('l');
}

export function messageDate(date, locale = 'ru') {
  const today = moment();
  const messageDate = moment(date);

  if (moment(date).startOf('day').isBefore(today.startOf('day'))) {
    return messageDate.locale(locale).format('DD.MM.YYYY');
  }

  return messageDate.locale(locale).format('LT');
}

export const humanizeTime = (date, locale = 'ru') => {
  const humanizedTime = moment(date);
  return humanizedTime.locale(locale).format('LT');
};

export const parseDate = (date, locale = 'ru') => {
  const humanizedTime = moment(date);
  if (moment(humanizedTime).isSame(new Date(), 'year') ){
    return humanizedTime.locale(locale).format('DD MMMM');
  }
  return humanizedTime.locale(locale).format('DD.MM.YYYY');
}
